import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfUC",
  "use": "BankOfUC-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfUC\">\r\n<defs>\r\n    <style>\r\n      #BankOfUC .cls-1 {\r\n        fill: #007f3e;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfUC_邮储logo\" class=\"cls-1\" d=\"M2661.24,504.8l-0.33,1.873h9.86l0.44-1.873h-9.97Zm25.08,1.873,0.33-1.873h-11.17l-0.44,1.873h11.28Zm6.24-9.473-1.53,7.6-0.44,1.873-1.54,7.6H2673.5l-0.32,1.761h18.17l2.41-11.234,1.54-7.6h21.79l-1.65,7.6h-17.41l-3.94,18.836h-22.56l-0.32,1.766h25.29l2.41-11.124,1.53-7.6h14.68l-1.54,7.6h-10.4l-2.3,11.129-1.64,7.6h-33.95l3.95-18.725H2655l1.64-7.6,0.33-1.877,1.64-7.6h14.13l3.94-18.725h15.55l1.98-9.473H2723l-1.64,7.6h-24.53l-0.33,1.873-1.53,7.6h-15.55l-0.44,1.763h18.29l0.33-1.763,1.64-7.6h21.79l-1.64,7.6h-17.41l-1.98,9.363h-22.55l-0.44,1.762h15.55Zm0,0\" transform=\"translate(-2655 -467)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfUC.svg
// module id = jxkn
// module chunks = 37